module.exports = __webpack_public_path__ + "img/EmailIcon.1524d10b.png";